import {
  isTeamMemberRole,
  normalizeHierarchyRoleCode,
} from "../pages/inboxReviewScope";

export function profileDisplayRole({
  isAdmin = false,
  hierarchyRoleCode,
} = {}) {
  const code = normalizeHierarchyRoleCode(hierarchyRoleCode);

  if (code === "DIRECTOR") {
    return { code: "DIRECTOR", label: "DIRECTOR", tone: "director" };
  }

  if (isAdmin || code === "ADMIN") {
    return { code: "ADMIN", label: "ADMIN", tone: "admin" };
  }

  if (code === "SENIOR_MANAGER") {
    return { code: "SENIOR_MANAGER", label: "SENIOR MANAGER", tone: "senior" };
  }

  if (code === "MANAGER") {
    return { code: "MANAGER", label: "MANAGER", tone: "manager" };
  }

  if (isTeamMemberRole(code)) {
    return { code: "TEAM_MEMBER", label: "TEAM MEMBER", tone: "member" };
  }

  return null;
}

export function profileShowsDepartment(role) {
  const code = role?.code;
  return Boolean(code) && code !== "ADMIN" && code !== "DIRECTOR";
}

export function isStrictTeamMember({
  isAdmin = false,
  hierarchyRoleCode,
  roles = [],
} = {}) {
  // Admins are NEVER team members
  if (isAdmin) {
    return false;
  }

  const normCode = normalizeHierarchyRoleCode(hierarchyRoleCode);
  if (normCode === "ADMIN") {
    return false;
  }

  const displayRole = profileDisplayRole({ isAdmin, hierarchyRoleCode });
  if (displayRole?.code === "ADMIN" || displayRole?.code === "DIRECTOR" || displayRole?.code === "MANAGER" || displayRole?.code === "SENIOR_MANAGER") {
    return false;
  }

  if (displayRole?.code === "TEAM_MEMBER" || isTeamMemberRole(hierarchyRoleCode)) {
    return true;
  }

  return roles.some((r) => {
    const cleaned = String(r || "").trim().toUpperCase();
    return cleaned === "TEAM MEMBER" || cleaned === "TEAM_MEMBER" || cleaned === "TM";
  });
}
